export const name = 'rendererConfiguration' as const

export const HIPAA_COMPLIANT_HEADER = 'x-wix-hipaa-compliant'
